export default {
  'resultandsuccess.success.title': 'Submission Success',
  'resultandsuccess.success.description':
    'The submission results page is used to feed back the results of a series of operational tasks. If it is a simple operation, use the Message global prompt feedback. This text area can show a simple supplementary explanation. If there is a similar requirement for displaying “documents”, the following gray area can present more complicated content.',
  'resultandsuccess.success.operate-title': 'Project Name',
  'resultandsuccess.success.operate-id': 'Project ID',
  'resultandsuccess.success.principal': 'Principal',
  'resultandsuccess.success.operate-time': 'Effective time',
  'resultandsuccess.success.step1-title': 'Create project',
  'resultandsuccess.success.step1-operator': 'Qu Lili',
  'resultandsuccess.success.step2-title': 'Departmental preliminary review',
  'resultandsuccess.success.step2-operator': 'Zhou Maomao',
  'resultandsuccess.success.step2-extra': 'Urge',
  'resultandsuccess.success.step3-title': 'Financial review',
  'resultandsuccess.success.step4-title': 'Finish',
  'resultandsuccess.success.btn-return': 'Back List',
  'resultandsuccess.success.btn-project': 'View Project',
  'resultandsuccess.success.btn-print': 'Print',
};
